import { render } from "./SectionPatron.vue?vue&type=template&id=cf3c47aa"
import script from "./SectionPatron.vue?vue&type=script&lang=js"
export * from "./SectionPatron.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__